import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=1c1d0331&scoped=true&"
import script from "./ModuleList.vue?vue&type=script&lang=js&"
export * from "./ModuleList.vue?vue&type=script&lang=js&"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=1c1d0331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d0331",
  null
  
)

export default component.exports